import { useState, useEffect } from 'react';
import { Select } from '@components/index';

type FilterProps = {
    meta: any;
	header?: any;
    filterData: any;
    onChange: (val:any) => void;
}

export const FilterSelect = (props:FilterProps) => {
	const {
		meta,
		header,
		filterData,
		onChange
	} = props;
	const [selectVal, setSelectVal] = useState('');
	const [selectOptions, setSelectOptions] = useState<any[]>([]);
	const filterOptions = meta?.filterOptions?.options ?? [];
	const placeholder = meta?.filterOptions?.allowPlaceHolder ?? '';
	const updateVal = (v:any) => {
		setSelectVal(v);
		const newFilterData = { ...filterData };
		newFilterData.value = v;
		newFilterData.columnField = meta?.databaseLocation ?? header;
		newFilterData.operatorValue = 'is';
		onChange(newFilterData);
	}
	const generateSelectOptions = (options:any[]) => {
		const opts = options.map((opt) => {
			return typeof opt === 'string' ? { value: opt, label: opt } : opt;
		});

		return opts;
	}
	useEffect(() => {
		setSelectOptions(generateSelectOptions(filterOptions));
	}, [meta]);
	useEffect(() => {
		if (filterData?.value) {
			setSelectVal(filterData.value || '');
		} else {
			setSelectVal('');
		}
	}, [filterData]);
	return (
		<Select name={'Filter-Option-Select'} value={selectVal} onChange={(v) => updateVal(v)} placeholder={placeholder}>
			{selectOptions.map((option, i) => {
				return <Select.Option key={i} value={option.value}>{option.label}</Select.Option>
			})}
		</Select>
	);
}
